<template>
    <div class="container">
        <div class="cat">
            <h2>{{ title }}</h2>
            <p>{{ sDesc }}</p>
            <p>{{ sContent }}</p>
            <p>
                <a href=""> {{ link }}</a>
            </p>
            <el-image style="width: 300px; height: 300px" :src="fileDataUrl">
            </el-image>

        </div>

        <!-- <div>
            点击跳转到微信
        </div> -->
    </div>
</template>
	
<script type="text/ecmascript-6">
// import "../../SDK/dy_sdk"
// import {  } from "../../api/userMG.js";
export default {
    data() {
        return {
            fileDataUrl: "",
            title: "",
            sDesc: "",
            link: "",
            sContent: "",
        };
    },
    created() {
        const dy_sdk = window.douyin_open;
        dy_sdk.config({
            params: {
                client_key: res.client_key, // clientKey在你的网页应用申请通过后得到
                signature: res.signature, // 服务端计算的签名，该签名被抖音开放平台验证通过后方可调用jsb方法
                timestamp: String(res.timestamp), // 时间戳必须是字符串
                nonce_str: res.nonce_str,//生成签名用的随机字符串
                url: location.href, // 为应用申请的 JSB 安全域名下的链接，需要携带协议。e.g. https://jsb.security.domain/page.html
            },
        });
    },
    methods: {

    }
};
</script>
<style>
.cat {
    width: 500px;
    height: 600px;
    margin: 0 auto;
    text-align: center;
}

p {
    margin: 10px 0;
}
</style>
  




// WEBPACK FOOTER //
// src/views/login/dyC.vue